
import Vue from 'vue'
import App from './App'
import router from './router'
import apiFun from "@/http/api.js";
import store from '@/store/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

Vue.prototype.$apiFun = apiFun;

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  
  window.scrollTo(0, 0);

});
router.beforeEach((to, from, next) => {
  let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
  if (to.matched.some(res => res.meta.requireAuth)) { 
    if (sessionStorage.getItem('token')) { 
      next();
    } else {
      next({
        path: '/login', 
        query: { redirect: to.fullPath } 
      });
    }
  } else {
    next();
  }
// 天美社区源码网 timibbs.net timibbs.com timibbs.vip

});
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js